import React, { Fragment, useEffect, useState } from "react";
import useAuth from "src/hooks/useAuth";
import logo from "src/assets/logo.png";
import { useDispatch, useSelector } from "react-redux";
import {
  currentOfficeSelector,
  initOfficeList,
  initPublicOfficeList,
  officesSelector,
  setOffice,
  currentPublicOfficeSelector,
} from "src/slices/office";
import "./navbar.css";
import _ from "lodash";
import { useHistory } from "react-router";
import PublicPopup from "src/components/PublicPopup";
import GlobalSearch from "src/components/GlobalSearch";
import PublicMenu from "./components/PublicMenu";

const TopBar = props => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const history = useHistory();
  const offices = useSelector(officesSelector);
  const currentOffice = useSelector(currentOfficeSelector);
  const currentPublicOffice = useSelector(currentPublicOfficeSelector);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { onBellClicked, notiUnreadNum, postObj } = props;

  useEffect(() => {
    if (user) dispatch(initOfficeList());
    else dispatch(initPublicOfficeList());
  }, []);

  const changeOffice = officeId => {
    if (officeId < 0) {
      history.push("/office/setup");
      return;
    }

    if (officeId != currentOffice.id) {
      dispatch(setOffice(offices.find(office => office.id === officeId)));
      if (user) history.push("/posts");
      else history.push(`/public_offices/${officeId}/posts`);
    }
  };

  useEffect(() => {
    if (postObj.office_id && postObj.post_id) {
      if (postObj.office_id.toString() !== currentOffice.id) {
        dispatch(
          setOffice(
            offices.find(office => office.id === postObj.office_id.toString())
          )
        );
      }
      history.push(`/posts/${postObj.post_id}/detail?oid=${postObj.office_id}`);
    }
  }, [postObj]);

  const onBellIconClicked = () => {
    if (user) onBellClicked();
    else setIsOpenModal(true);
  };

  const onPublicMenuClick = () => {
    setIsOpenModal(true);
  };

  const onPublicOffices = () => {
    if (user) history.push("/public_offices");
    else history.push("/discover");
  };

  const onPublicOfficePosts = () => {
    history.push(`/public_offices/${currentPublicOffice.id}/posts`);
  };

  if (!user) {
    return (
      <>
        <Fragment>
          <div className="my-6 flex flex-col lg:flex-row justify-between items-center gap-3">
            <div>
              <div className="flex flex-col lg:flex-row justify-center items-center gap-4">
                <div className="lg:px-4 w-full lg:w-auto">
                  <div className="flex justify-between items-center">
                    <a href="https://www.legislata.com">
                      <img src={logo} width="120" />
                    </a>
                    <div className="lg:hidden flex flex-row gap-8">
                      <button
                        type="button"
                        className="text-white bg-red-800 hover:bg-red-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                        onClick={() => history.push("/login")}
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row gap-1 items-center">
                  <PublicMenu title="Discover" onMenuClick={onPublicOffices} />
                  <PublicMenu title="Data" onMenuClick={onPublicMenuClick} />
                  {currentPublicOffice && (
                    <PublicMenu
                      title="Posts"
                      onMenuClick={onPublicOfficePosts}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="hidden lg:block lg:flex lg:flex-row lg:gap-8 lg:items-center">
              <button
                type="button"
                className="text-blue-700 font-medium underline"
                onClick={() => history.push("/login")}
              >
                Login
              </button>
              <button
                type="button"
                className="text-blue-700 font-medium underline"
                onClick={() => history.push("/register")}
              >
                Register
              </button>
              <button
                type="button"
                className="text-white bg-red-800 hover:bg-red-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                onClick={() =>
                  (window.location.href = "https://www.legislata.com/welcome")
                }
              >
                Learn More &rarr;
              </button>
            </div>
          </div>
        </Fragment>
        <PublicPopup
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        />
      </>
    );
  }

  const { onMenuClick } = props;

  return (
    <div className="topbar h-16 flex justify-between items-center px-4 md:px-8 z-20 bg-white fixed border-gray-300 border-b-1">
      <div className="flex items-center justify-start space-x-2 md:space-x-4 flex-1 min-w-0">
        {/* Hamburger Menu Button - Mobile Only */}
        <button
          className="lg:hidden p-2 hover:bg-gray-100 rounded-md flex-shrink-0"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        {/* Office Selector - Desktop Only */}
        <div
          className={`${user ? "" : "hidden"} hidden lg:block flex-shrink-0`}
        >
          {offices.length === 0 ? (
            <div className="text-base truncate">
              {currentOffice?.attributes?.name}
            </div>
          ) : (
            <select
              className="border-none focus:border-none focus:border-0 text-base"
              onChange={e => changeOffice(e.target.value)}
              value={currentOffice.id === null ? "" : currentOffice.id}
              disabled={user ? null : true}
            >
              {offices.map(office => (
                <option key={office.id} value={office.id}>
                  {office.attributes.name}
                </option>
              ))}
            </select>
          )}
        </div>

        {/* Global Search */}
        <div className="flex-1 min-w-0 max-w-xl">
          <GlobalSearch />
        </div>
      </div>
      {/* Desktop-only: Notifications and Account */}
      <div className="hidden lg:flex items-center justify-end space-x-4 flex-shrink-0 ml-4">
        <span
          className="relative inline-block cursor-pointer"
          onClick={onBellIconClicked}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-7 h-7 text-gray-700"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
          {notiUnreadNum !== 0 && (
            <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full">
              {notiUnreadNum}
            </span>
          )}
        </span>
        {user ? (
          <a title="My Account" href="/account">
            <div className="w-8 h-8 rounded-full bg-brand-default text-white flex items-center justify-center border-0 text-sm">
              {user.attributes.first_name[0]}
              {user.attributes.last_name[0]}
            </div>
          </a>
        ) : (
          <div className="mt-2">
            <button
              type="button"
              className="text-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-1.5 text-center mr-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-600 dark:focus:ring-blue-800"
              onClick={() => history.push("/login")}
            >
              Login
            </button>
            <button
              type="button"
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              onClick={() => history.push("/register")}
            >
              Register
            </button>
            <button
              type="button"
              className="text-white bg-red-800 hover:bg-red-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              onClick={() =>
                (window.location.href = "https://www.legislata.com/welcome")
              }
            >
              Learn More &rarr;
            </button>
          </div>
        )}
      </div>
      <PublicPopup isOpen={isOpenModal} onClose={() => setIsOpenModal(false)} />
    </div>
  );
};

export default TopBar;
